
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogActions,
    DialogContent,
    Slide,
    Paper,
    FormControl,
    FormControlLabel,
    InputLabel,
    Select,
    Switch,
    Autocomplete,
    Tooltip,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewFilterModel,
        ListViewColumnModel,
        RecordModel,
        FieldMetadataModel,
        ActionModel} from '../../models/models';
import {ListConfigurationModel,
        ListViewConfigurationModel} from '../../models/modelsListConfiguration';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {fetchFields, initListViewFilter} from "../../services/metadataApi";
import {DndContext,
        closestCenter,
        PointerSensor,
        useSensor,
        useSensors} from "@dnd-kit/core";
import type { Modifier } from "@dnd-kit/core";
import {SortableContext,
        useSortable,
        verticalListSortingStrategy } from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export const ListFilterSaveComponent: React.FC<{
  displaySaveDialog: boolean,
  listConfig: ListConfigurationModel,
  onCloseDialog: () => void,
  onSave: (overwriteList: boolean, listLabel: string) => void
}> = ({
  displaySaveDialog,
  listConfig,
  onCloseDialog,
  onSave
}) => {


  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [overwriteList, setOverwriteList] = useState<boolean>(true);
  const [listLabel, setListLabel] = useState<string>(listConfig.listViewLabel);

  const closeDialog = () => {
    onCloseDialog()
  }

  const saveListView = () => {
    onSave(overwriteList, listLabel)
  }


  return (
    <Dialog
          open={displaySaveDialog}
          onClose={() => closeDialog()}
          fullWidth
          maxWidth={'md'}
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '30vh'
            }
          }}
    >

      <DialogTitle>
        <Toolbar sx={{justifyContent: 'space-between'}}>
          <Typography variant="h6">
            Save List View
          </Typography>

          <IconButton
            edge="start"
            color="inherit"
            onClick={() => closeDialog()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </DialogTitle>

      <Box sx={{height: '100%'}}>

        <DialogActions>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => {saveListView()}}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Typography variant='body2'>
                Save
              </Typography>
              <SaveIcon fontSize="small"/>
            </Box>
          </Button>
        </DialogActions>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2
          }}
        >
          <TextField
            fullWidth
            disabled={false}
            multiline={false}
            rows={1}
            required={true}
            size="small"
            label={"List View Label"}
            variant="filled"
            value={listLabel}
            onChange={(event) => {setListLabel(event.target.value)}}
          />

          <FormControl
            fullWidth
            variant="filled"
          >
            <FormControlLabel
              label={'Update current List View?'}
              control={
                <Switch
                  size="small"
                  checked={overwriteList}
                  onChange={(event) => setOverwriteList(!overwriteList)}
                  disabled={false}
                />
              }
              labelPlacement="top"
            />
          </FormControl>

        </DialogContent>

      </Box>
    </Dialog>

  );

};
